<div class="relative overflow-hidden flex flex-col max-h-full">
  <!-- Barra de progreso -->

  <div class="sticky rounded-lg top-0 bg-white z-10 p-4">
    <div class="relative">
      <h1 class="text-4xl pb-3">
        <b>{{ curso?.titulo || 'Sin titulo' }}</b>
      </h1>
      <div
        class="absolute bottom-0 left-0 h-px bg-blue-500 z-20"
        [style.width.%]="scrollProgress"
      ></div>
    </div>
  </div>
  <div class="overflow-auto flex-1" #content (scroll)="onScroll(content)">
    <div class="p-4">
      <cite>{{ curso?.descripcion || 'Sin descripción' }}</cite>
    </div>
    <div
      class="ql-editor"
      style="overflow: hidden !important; height: auto"
      [innerHTML]="html"
    ></div>

    @if (!finalizado) {
      <div class="flex justify-end">
        <petrol-button variant="primary" (click)="marcarFinalizado()">Finalizar</petrol-button>
      </div>
    }

    <br />
  </div>
</div>

<c-dialog #dialog />
